"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Client = exports.listName = exports.expand = void 0;
var dayjs_1 = __importDefault(require("dayjs"));
var debug_1 = __importDefault(require("debug"));
var chunk_1 = __importDefault(require("lodash/chunk"));
var difference_1 = __importDefault(require("lodash/difference"));
var flatMap_1 = __importDefault(require("lodash/flatMap"));
var groupBy_1 = __importDefault(require("lodash/groupBy"));
var map_1 = __importDefault(require("lodash/map"));
var orderBy_1 = __importDefault(require("lodash/orderBy"));
var pick_1 = __importDefault(require("lodash/pick"));
var sortBy_1 = __importDefault(require("lodash/sortBy"));
var uniq_1 = __importDefault(require("lodash/uniq"));
var _1 = require(".");
var helpers_1 = require("./utils/helpers");
var resolvable_promise_1 = require("./utils/resolvable-promise");
var todayInNj_1 = require("./utils/todayInNj");
var debug = (0, debug_1.default)('nuts:ad');
exports.expand = [
    'customer',
    'lineItems[*].variant',
    'lineItems[*].variant.prices[*].channel',
];
exports.listName = 'Auto-Delivery';
var maximumListLength = 100;
// For storing state without annoying Vuex
var storageByClient = new WeakMap();
var Client = /** @class */ (function () {
    function Client(api, customerApi) {
        this.api = api;
        var storage = {
            addressesById: new Map(),
            addressPromisesById: new Map(),
            productInfoById: new Map(),
            productInfoPromisesById: new Map(),
        };
        storageByClient.set(this, storage);
        this.shoppingLists = customerApi.shoppingLists();
    }
    Object.defineProperty(Client.prototype, "storage", {
        get: function () {
            return storageByClient.get(this); // it was definitely set in the constructor
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(Client.prototype, "customer", {
        get: function () {
            return this.storage.customer;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(Client.prototype, "paymentMethod", {
        get: function () {
            return this.storage.paymentMethod;
        },
        enumerable: false,
        configurable: true
    });
    /** @deprecated since 0.3.8; use proposedDelivery.getPaymentMethod() */
    Client.prototype.getPaymentMethod = function () {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                return [2 /*return*/, this.fetchPaymentMethod()];
            });
        });
    };
    Client.prototype.getSubscriptions = function (_a) {
        var _b = _a === void 0 ? {} : _a, force = _b.force, includeInactive = _b.includeInactive, preloadImagesAndPaths = _b.preloadImagesAndPaths, preloadPaymentMethod = _b.preloadPaymentMethod, preloadShippingAddresses = _b.preloadShippingAddresses;
        return __awaiter(this, void 0, void 0, function () {
            var softRequired, lineItems, isActive, isCompleteLineItem, isNotFulfilledOneTimePurchase, tolerateRejection, subscriptions;
            var _this = this;
            return __generator(this, function (_c) {
                switch (_c.label) {
                    case 0:
                        softRequired = {
                            preloadImagesAndPaths: preloadImagesAndPaths,
                            preloadPaymentMethod: preloadPaymentMethod,
                            preloadShippingAddresses: preloadShippingAddresses,
                        };
                        Object.entries(softRequired)
                            .filter(function (_a) {
                            var _ = _a[0], value = _a[1];
                            return value === undefined;
                        })
                            .map(function (_a) {
                            var key = _a[0];
                            return debug('warning: please specify %s — its default will change soon', key);
                        });
                        return [4 /*yield*/, this.getLineItems({ force: force })];
                    case 1:
                        lineItems = _c.sent();
                        isActive = function (l) { var _a; return includeInactive || ((_a = l.custom) === null || _a === void 0 ? void 0 : _a.fields.active); };
                        isCompleteLineItem = function (l) { var _a; return l.custom && ((_a = l.variant) === null || _a === void 0 ? void 0 : _a.sku); };
                        isNotFulfilledOneTimePurchase = function (l) { var _a, _b; return ((_a = l.custom) === null || _a === void 0 ? void 0 : _a.fields.active) || !!((_b = l.custom) === null || _b === void 0 ? void 0 : _b.fields.interval); };
                        lineItems = lineItems
                            .filter(isActive)
                            .filter(isCompleteLineItem)
                            .filter(isNotFulfilledOneTimePurchase);
                        if (!lineItems.length) {
                            return [2 /*return*/, []];
                        }
                        tolerateRejection = function (p) {
                            return p.catch(function () {
                                // ignore preload failures; waitForPreloads can report if desired
                            });
                        };
                        if (preloadImagesAndPaths !== null && preloadImagesAndPaths !== void 0 ? preloadImagesAndPaths : true) {
                            tolerateRejection(this.fetchProducts(lineItems));
                        }
                        if (preloadPaymentMethod !== null && preloadPaymentMethod !== void 0 ? preloadPaymentMethod : true) {
                            tolerateRejection(this.fetchPaymentMethod());
                        }
                        if (preloadShippingAddresses !== null && preloadShippingAddresses !== void 0 ? preloadShippingAddresses : true) {
                            tolerateRejection(this.fetchShippingAddresses(lineItems));
                        }
                        return [4 /*yield*/, this.waitForPreloads({ throwError: false })];
                    case 2:
                        _c.sent();
                        subscriptions = lineItems.map(function (lineItem) {
                            var _a;
                            return new _1.Subscription(_this, lineItem, _this.storage.addressesById.get(String((_a = lineItem.custom) === null || _a === void 0 ? void 0 : _a.fields.shippingAddressId)), _this.storage.productInfoById.get(lineItem.productId));
                        });
                        return [2 /*return*/, (0, orderBy_1.default)(subscriptions, ['cancelledAt', 'nextShipOn', 'shippingAddressId'], ['desc', 'asc', 'asc'])];
                }
            });
        });
    };
    Client.prototype.getNextDeliveries = function (requestArgs) {
        return __awaiter(this, void 0, void 0, function () {
            var subscriptions, deliveries, recurringSubscriptions, oneTimeSubscriptions, deliveryGroups, subsWithShipOn, groups;
            var _this = this;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.getSubscriptions(requestArgs)];
                    case 1:
                        subscriptions = _a.sent();
                        debug('have payment method? %j', Boolean(this.paymentMethod));
                        debug('subscriptions having addresses: %d of %d', subscriptions.filter(function (_a) {
                            var shippingAddress = _a.shippingAddress;
                            return shippingAddress;
                        }).length, subscriptions.length);
                        deliveries = [];
                        if (requestArgs === null || requestArgs === void 0 ? void 0 : requestArgs.groupByInterval) {
                            recurringSubscriptions = subscriptions.filter(function (subscription) { return !!subscription.nextShipOn && !!subscription.interval; });
                            oneTimeSubscriptions = subscriptions.filter(function (subscription) { return !!subscription.nextShipOn && !subscription.interval; });
                            deliveryGroups = this.mapDeliveryGroups(recurringSubscriptions, oneTimeSubscriptions);
                            deliveries = Array.from(deliveryGroups.values()).map(function (subs) { return new _1.ProposedDelivery(_this, subs, true); });
                        }
                        else {
                            subsWithShipOn = subscriptions.filter(function (subscription) { return subscription.nextShipOn; });
                            groups = (0, groupBy_1.default)(subsWithShipOn, function (subscription) {
                                return "".concat(subscription.nextShipOn, ":").concat(subscription.shippingAddressId).concat((requestArgs === null || requestArgs === void 0 ? void 0 : requestArgs.groupByInterval) ? ":".concat(subscription.interval) : '');
                            });
                            deliveries = (0, map_1.default)(groups, function (subs) { return new _1.ProposedDelivery(_this, subs); });
                        }
                        return [2 /*return*/, (0, sortBy_1.default)(deliveries, ['shipOn', 'shippingAddressId'])];
                }
            });
        });
    };
    Client.prototype.mapDeliveryGroups = function (recurringSubscriptions, oneTimeSubscriptions) {
        var deliveryGroups = new Map();
        var oneTimeKeyMap = new Map();
        recurringSubscriptions.forEach(function (sub) {
            var _a;
            var oneTimeKey = "".concat(sub.nextShipOn, ":").concat(sub.shippingAddressId);
            var key = "".concat(oneTimeKey, ":").concat(sub.interval);
            if (!deliveryGroups.has(key)) {
                deliveryGroups.set(key, [sub]);
                oneTimeKeyMap.set(oneTimeKey, key);
            }
            else {
                (_a = deliveryGroups.get(key)) === null || _a === void 0 ? void 0 : _a.push(sub);
            }
        });
        oneTimeSubscriptions.forEach(function (sub) {
            var _a;
            var oneTimeKey = "".concat(sub.nextShipOn, ":").concat(sub.shippingAddressId);
            var key = oneTimeKeyMap.get(oneTimeKey) || oneTimeKey;
            if (!deliveryGroups.has(key)) {
                deliveryGroups.set(key, []);
            }
            (_a = deliveryGroups.get(key)) === null || _a === void 0 ? void 0 : _a.push(sub);
        });
        return deliveryGroups;
    };
    Client.prototype.getImpulseUpsellEligible = function (requestArgs) {
        return __awaiter(this, void 0, void 0, function () {
            var nextDelivery, error_1;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _a.trys.push([0, 2, , 3]);
                        return [4 /*yield*/, this.getNextDeliveries(__assign({ preloadImagesAndPaths: false, preloadPaymentMethod: false, preloadShippingAddresses: false }, requestArgs))];
                    case 1:
                        nextDelivery = (_a.sent())[0];
                        return [2 /*return*/, nextDelivery];
                    case 2:
                        error_1 = _a.sent();
                        return [2 /*return*/, undefined];
                    case 3: return [2 /*return*/];
                }
            });
        });
    };
    Client.prototype.checkIfShoppingListIsFull = function (list) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                return [2 /*return*/, list.lineItems && list.lineItems.length >= maximumListLength];
            });
        });
    };
    Client.prototype.createAndSetLists = function (draft) {
        return __awaiter(this, void 0, void 0, function () {
            var lists, _a, _b, _c;
            return __generator(this, function (_d) {
                switch (_d.label) {
                    case 0:
                        _a = [[]];
                        return [4 /*yield*/, this.getLists()];
                    case 1:
                        lists = __spreadArray.apply(void 0, _a.concat([(_d.sent()), true]));
                        _c = (_b = lists).unshift;
                        return [4 /*yield*/, this.createList({ lineItems: [draft] })];
                    case 2:
                        _c.apply(_b, [_d.sent()]);
                        this.setLists(lists);
                        return [2 /*return*/];
                }
            });
        });
    };
    Client.prototype.getLatestShoppingList = function () {
        return __awaiter(this, void 0, void 0, function () {
            var lists;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.getLists()];
                    case 1:
                        lists = _a.sent();
                        return [2 /*return*/, lists[0]];
                }
            });
        });
    };
    Client.prototype.addLineItem = function (draft) {
        return __awaiter(this, void 0, void 0, function () {
            var latest, _a, lists, _b, _c, _d;
            return __generator(this, function (_e) {
                switch (_e.label) {
                    case 0: return [4 /*yield*/, this.getLatestShoppingList()];
                    case 1:
                        latest = _e.sent();
                        _a = latest;
                        if (!_a) return [3 /*break*/, 3];
                        return [4 /*yield*/, this.checkIfShoppingListIsFull(latest)];
                    case 2:
                        _a = !(_e.sent());
                        _e.label = 3;
                    case 3:
                        if (!_a) return [3 /*break*/, 6];
                        _b = [[]];
                        return [4 /*yield*/, this.getLists()];
                    case 4:
                        lists = __spreadArray.apply(void 0, _b.concat([(_e.sent()), true]));
                        _c = lists;
                        _d = 0;
                        return [4 /*yield*/, this.updateList(lists[0], [
                                __assign({ action: 'addLineItem' }, draft),
                            ])];
                    case 5:
                        _c[_d] = _e.sent();
                        // update our cache with the new version
                        this.setLists(lists);
                        return [3 /*break*/, 8];
                    case 6: 
                    // otherwise create a new one
                    return [4 /*yield*/, this.createAndSetLists(draft)];
                    case 7:
                        // otherwise create a new one
                        _e.sent();
                        _e.label = 8;
                    case 8: return [2 /*return*/];
                }
            });
        });
    };
    Client.prototype.buildLineItemUpdateActionsByList = function (actions) {
        var _a;
        return __awaiter(this, void 0, void 0, function () {
            var lists, listsByLine, actionsByList, _i, actions_1, action, list;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        if (!actions.length) {
                            return [2 /*return*/];
                        }
                        return [4 /*yield*/, this.getLists()];
                    case 1:
                        lists = _b.sent();
                        if (!lists.length) {
                            return [2 /*return*/, false];
                        }
                        listsByLine = {};
                        lists.forEach(function (list) { var _a; return (_a = list.lineItems) === null || _a === void 0 ? void 0 : _a.forEach(function (lineItem) { return (listsByLine[lineItem.id] = list); }); });
                        actionsByList = new Map(lists.map(function (list) { return [list, []]; }));
                        for (_i = 0, actions_1 = actions; _i < actions_1.length; _i++) {
                            action = actions_1[_i];
                            list = listsByLine[action.lineItemId];
                            (_a = actionsByList.get(list)) === null || _a === void 0 ? void 0 : _a.push(action);
                        }
                        return [2 /*return*/, lists.map(function (list) { return ({ list: list, actions: actionsByList.get(list) }); })];
                }
            });
        });
    };
    Client.prototype.updateLineItems = function (actions) {
        return __awaiter(this, void 0, void 0, function () {
            var actionsByList, updates, _a;
            var _this = this;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0: return [4 /*yield*/, this.buildLineItemUpdateActionsByList(actions)];
                    case 1:
                        actionsByList = _b.sent();
                        if (!actionsByList) {
                            return [2 /*return*/];
                        }
                        updates = actionsByList.map(function (_a) {
                            var list = _a.list, listActions = _a.actions;
                            return _this.updateList(list, listActions);
                        });
                        _a = this.setLists;
                        return [4 /*yield*/, Promise.all(updates)];
                    case 2:
                        _a.apply(this, [_b.sent()]);
                        return [2 /*return*/];
                }
            });
        });
    };
    Client.prototype.fetchProducts = function (lineItems) {
        return __awaiter(this, void 0, void 0, function () {
            var myIds, promisedIds, neededIds, chunkSize;
            var _this = this;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        myIds = (0, uniq_1.default)(lineItems.map(function (li) { return li.productId; }));
                        promisedIds = this.storage.productInfoPromisesById.keys();
                        neededIds = (0, difference_1.default)(myIds, Array.from(promisedIds));
                        debug('need %d products', neededIds.length);
                        if (!neededIds.length) {
                            return [2 /*return*/];
                        }
                        // make promises first, to avoid racing
                        neededIds.forEach(function (id) {
                            var r = (0, resolvable_promise_1.resolvablePromise)();
                            _this.storage.productInfoPromisesById.set(id, r);
                        });
                        chunkSize = 40;
                        return [4 /*yield*/, Promise.all((0, chunk_1.default)(neededIds, chunkSize).map(function (ids) { return __awaiter(_this, void 0, void 0, function () {
                                var request, response, _loop_1, this_1, _i, _a, product, error_2;
                                var _this = this;
                                var _b, _c;
                                return __generator(this, function (_d) {
                                    switch (_d.label) {
                                        case 0:
                                            debug('querying for %d products', ids.length);
                                            request = this.api.products().get({
                                                queryArgs: {
                                                    expand: 'masterData.current.categories[*].ancestors[*]',
                                                    where: "id in (\"".concat(ids.join('","'), "\")"),
                                                    limit: ids.length,
                                                },
                                            });
                                            _d.label = 1;
                                        case 1:
                                            _d.trys.push([1, 3, , 4]);
                                            return [4 /*yield*/, request.execute()];
                                        case 2:
                                            response = _d.sent();
                                            if (!response.body.count) {
                                                throw new Error('products not found');
                                            }
                                            debug('got %d products in response', response.body.count);
                                            _loop_1 = function (product) {
                                                var _e = product.masterData.current, categories = _e.categories, _f = _e.masterVariant, attributes = _f.attributes, images = _f.images;
                                                var flattened = (0, helpers_1.pivotAttributeValues)(attributes);
                                                var cat = (_b = categories.find(function (cr) { return cr.id === flattened.product.primaryCategory.id; })) === null || _b === void 0 ? void 0 : _b.obj;
                                                var productPath = cat && (0, helpers_1.buildPath)(cat, flattened.product.urlName, debug);
                                                (_c = this_1.storage.productInfoPromisesById
                                                    .get(product.id)) === null || _c === void 0 ? void 0 : _c.resolve({ images: images, productPath: productPath });
                                                this_1.storage.productInfoById.set(product.id, {
                                                    images: images,
                                                    productPath: productPath,
                                                });
                                            };
                                            this_1 = this;
                                            for (_i = 0, _a = response.body.results; _i < _a.length; _i++) {
                                                product = _a[_i];
                                                _loop_1(product);
                                            }
                                            ids.forEach(function (id) {
                                                var _a;
                                                return (_a = _this.storage.productInfoPromisesById
                                                    .get(id)) === null || _a === void 0 ? void 0 : _a.reject(new Error("product ".concat(id, " not found")));
                                            });
                                            return [3 /*break*/, 4];
                                        case 3:
                                            error_2 = _d.sent();
                                            ids.forEach(function (id) { var _a; return (_a = _this.storage.productInfoPromisesById.get(id)) === null || _a === void 0 ? void 0 : _a.reject(error_2); });
                                            return [3 /*break*/, 4];
                                        case 4: return [2 /*return*/];
                                    }
                                });
                            }); }))];
                    case 1:
                        _a.sent();
                        return [2 /*return*/];
                }
            });
        });
    };
    Client.prototype.fetchPaymentMethod = function (_a) {
        var _b;
        var _c = _a === void 0 ? {} : _a, _d = _c.force, force = _d === void 0 ? false : _d;
        return __awaiter(this, void 0, void 0, function () {
            var _e, promise, _f, error_3;
            var _this = this;
            return __generator(this, function (_g) {
                switch (_g.label) {
                    case 0:
                        debug('getting payment method');
                        if (!(!this.paymentMethod || force)) return [3 /*break*/, 7];
                        _g.label = 1;
                    case 1:
                        _g.trys.push([1, 6, , 7]);
                        if (!this.storage.paymentMethodPromise) return [3 /*break*/, 3];
                        _e = this.storage;
                        return [4 /*yield*/, this.storage.paymentMethodPromise];
                    case 2:
                        _e.paymentMethod = _g.sent();
                        return [3 /*break*/, 5];
                    case 3:
                        promise = _1.webstore
                            .getPaymentMethod((_b = this.customer) === null || _b === void 0 ? void 0 : _b.id)
                            .then(function (paymentMethod) { return _this.checkExpiration(paymentMethod); });
                        this.storage.paymentMethodPromise = promise;
                        _f = this.storage;
                        return [4 /*yield*/, promise];
                    case 4:
                        _f.paymentMethod = _g.sent();
                        debug('got payment method');
                        _g.label = 5;
                    case 5:
                        this.storage.paymentMethodPromise = undefined;
                        return [3 /*break*/, 7];
                    case 6:
                        error_3 = _g.sent();
                        throw this.prefixError(error_3, 'while fetching payment method: ');
                    case 7: return [2 /*return*/, this.paymentMethod];
                }
            });
        });
    };
    Client.prototype.fetchShippingAddresses = function (lineItems) {
        return __awaiter(this, void 0, void 0, function () {
            var myIds, promisedIds, neededIds, chunkSize;
            var _this = this;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        myIds = (0, uniq_1.default)(lineItems.map(function (li) { var _a; return String((_a = li.custom) === null || _a === void 0 ? void 0 : _a.fields.shippingAddressId); })).filter(function (id) { return Number(id) > 0; });
                        promisedIds = this.storage.addressPromisesById.keys();
                        neededIds = (0, difference_1.default)(myIds, Array.from(promisedIds));
                        debug('need %d addresses', neededIds.length);
                        if (!neededIds.length) {
                            return [2 /*return*/];
                        }
                        // make promises first, to avoid racing
                        neededIds.forEach(function (id) {
                            var r = (0, resolvable_promise_1.resolvablePromise)();
                            _this.storage.addressPromisesById.set(id, r);
                        });
                        chunkSize = 150;
                        return [4 /*yield*/, Promise.all((0, chunk_1.default)(neededIds, chunkSize).map(function (ids) { return __awaiter(_this, void 0, void 0, function () {
                                var addresses, _i, addresses_1, address, id, error_4;
                                var _this = this;
                                var _a, _b;
                                return __generator(this, function (_c) {
                                    switch (_c.label) {
                                        case 0:
                                            debug('querying for %d addresses', ids.length);
                                            _c.label = 1;
                                        case 1:
                                            _c.trys.push([1, 3, , 4]);
                                            return [4 /*yield*/, _1.webstore.getShippingAddresses((_a = this.customer) === null || _a === void 0 ? void 0 : _a.id, ids)];
                                        case 2:
                                            addresses = _c.sent();
                                            if (!addresses) {
                                                throw new Error('addresses not found');
                                            }
                                            debug('got %d addresses in response', addresses.length);
                                            debug(addresses);
                                            for (_i = 0, addresses_1 = addresses; _i < addresses_1.length; _i++) {
                                                address = addresses_1[_i];
                                                id = String(address.id);
                                                (_b = this.storage.addressPromisesById.get(id)) === null || _b === void 0 ? void 0 : _b.resolve(address);
                                                this.storage.addressesById.set(id, address);
                                            }
                                            ids.forEach(function (id) {
                                                var _a;
                                                return (_a = _this.storage.addressPromisesById
                                                    .get(id)) === null || _a === void 0 ? void 0 : _a.reject(new Error("address ".concat(id, " not found")));
                                            });
                                            return [3 /*break*/, 4];
                                        case 3:
                                            error_4 = _c.sent();
                                            ids.forEach(function (id) { var _a; return (_a = _this.storage.addressPromisesById.get(id)) === null || _a === void 0 ? void 0 : _a.reject(error_4); });
                                            return [3 /*break*/, 4];
                                        case 4: return [2 /*return*/];
                                    }
                                });
                            }); }))];
                    case 1:
                        _a.sent();
                        return [2 /*return*/];
                }
            });
        });
    };
    /**
     * @deprecated since 0.3.8; use subscription.getAlternateVariants() instead
     */
    Client.prototype.getAlternateVariants = function (variant) {
        return __awaiter(this, void 0, void 0, function () {
            var resultMap, ogAttribute, swapGroup, request, body, sku, results;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        resultMap = new Map();
                        ogAttribute = variant.attributes.find(function (a) { return a.name === 'ordergrooveSkuSwapGroup'; });
                        if (!ogAttribute) {
                            return [2 /*return*/, resultMap];
                        }
                        swapGroup = ogAttribute.value;
                        request = this.api
                            .productProjections()
                            .search()
                            .get({
                            queryArgs: {
                                markMatchingVariants: true,
                                filter: [
                                    "variants.attributes.ordergrooveSkuSwapGroup:\"".concat(swapGroup, "\""),
                                    'variants.attributes.active:true',
                                    'variants.attributes.autoDeliveryEligible:true',
                                ],
                            },
                        });
                        return [4 /*yield*/, request.execute()];
                    case 1:
                        body = (_a.sent()).body;
                        if (body.count === 0) {
                            return [2 /*return*/, resultMap];
                        }
                        sku = variant.sku;
                        results = body.results;
                        results.forEach(function (product) {
                            var masterVariant = product.masterVariant, variants = product.variants;
                            var matchingVariants = __spreadArray([masterVariant], variants, true).filter(function (a) { return a.isMatchingVariant && a.sku !== sku; });
                            if (matchingVariants.length > 0) {
                                resultMap.set(product.name, matchingVariants);
                            }
                        });
                        return [2 /*return*/, resultMap];
                }
            });
        });
    };
    Client.prototype.setLists = function (lists) {
        var _a;
        if (!(lists === null || lists === void 0 ? void 0 : lists.length)) {
            delete this.storage.lists;
            return [];
        }
        if ((_a = lists[0].customer) === null || _a === void 0 ? void 0 : _a.obj) {
            this.storage.customer = (0, pick_1.default)(lists[0].customer.obj, [
                'id',
                'email',
                'externalId',
                'key',
            ]);
        }
        else {
            debug("WARNING: List ".concat(lists[0].id, " does not have an associated Customer"));
        }
        var listWithoutFixedAddressItems = lists
            .map(function (list) { return (__assign(__assign({}, list), { lineItems: list.lineItems.filter(function (li) {
                var _a, _b;
                return !((_b = (_a = li.variant) === null || _a === void 0 ? void 0 : _a.attributes) === null || _b === void 0 ? void 0 : _b.reduce(function (hasFixed, a) { return hasFixed || a.name === 'fixedAddress'; }, false));
            }) })); })
            .filter(function (list) { return list.lineItems.length > 0; });
        this.storage.lists = listWithoutFixedAddressItems;
        return listWithoutFixedAddressItems;
    };
    Client.prototype.updateList = function (list, actions) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                return [2 /*return*/, actions
                        ? this.execute(this.shoppingLists.withId({ ID: list.id }).post({
                            body: { version: list.version, actions: actions },
                            queryArgs: { expand: exports.expand },
                        }))
                        : list];
            });
        });
    };
    /** @deprecated since 0.3.9; use .waitForPreloads() */
    Client.prototype.waitForAllAddresses = function () {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                return [2 /*return*/, this.waitForPreloads()];
            });
        });
    };
    Client.prototype.waitForPreloads = function (_a) {
        var _b = _a === void 0 ? {} : _a, _c = _b.throwError, throwError = _c === void 0 ? true : _c;
        return __awaiter(this, void 0, void 0, function () {
            var preloads, errors, message;
            return __generator(this, function (_d) {
                switch (_d.label) {
                    case 0:
                        preloads = [];
                        this.storage.addressPromisesById.forEach(function (p) { return preloads.push(p); });
                        this.storage.productInfoPromisesById.forEach(function (p) { return preloads.push(p); });
                        if (this.storage.paymentMethodPromise) {
                            preloads.push(this.storage.paymentMethodPromise);
                        }
                        errors = [];
                        preloads = preloads.map(function (promise) {
                            return promise.catch(function (error) {
                                var _a;
                                errors.push((_a = error.message) !== null && _a !== void 0 ? _a : error);
                                return undefined;
                            });
                        });
                        return [4 /*yield*/, Promise.all(preloads)];
                    case 1:
                        _d.sent();
                        if (errors.length > 0) {
                            message = "Failed to load ".concat(errors.length, " resource(s):\n").concat(errors.join('\n'));
                            if (throwError) {
                                throw new Error(message);
                            }
                            else {
                                debug("Error executing preload: ".concat(message));
                            }
                        }
                        return [2 /*return*/, errors.length === 0];
                }
            });
        });
    };
    Client.prototype.checkExpiration = function (paymentMethod) {
        var expiresOn = paymentMethod.expiresOn;
        var expiring = false;
        var expired = false;
        if (expiresOn) {
            var today = dayjs_1.default.utc((0, todayInNj_1.todayInNj)());
            var exp = dayjs_1.default.utc(expiresOn).endOf('month');
            expiresOn = exp.format('YYYY-MM-DD');
            // a month and a half before expiration, call it expiring
            var fourteenthOfPriorMonth = exp.date(14).subtract(1, 'month');
            expiring = today.isAfter(fourteenthOfPriorMonth);
            // the day after expiration, call it expired
            expired = today.isAfter(exp);
        }
        return __assign(__assign({}, paymentMethod), { expiresOn: expiresOn, expiring: expiring, expired: expired });
    };
    Client.prototype.getLineItems = function (_a) {
        var _b = _a === void 0 ? {} : _a, _c = _b.force, force = _c === void 0 ? false : _c;
        return __awaiter(this, void 0, void 0, function () {
            var lists;
            return __generator(this, function (_d) {
                switch (_d.label) {
                    case 0: return [4 /*yield*/, this.getLists({ force: force })];
                    case 1:
                        lists = _d.sent();
                        return [2 /*return*/, (0, flatMap_1.default)(lists, function (list) { var _a; return (_a = list.lineItems) !== null && _a !== void 0 ? _a : []; })];
                }
            });
        });
    };
    Client.prototype.getLists = function (_a) {
        var _b;
        var _c = _a === void 0 ? {} : _a, _d = _c.force, force = _d === void 0 ? false : _d, queryArgs = _c.queryArgs;
        return __awaiter(this, void 0, void 0, function () {
            var isIe, bustIeCache, request, body;
            return __generator(this, function (_e) {
                switch (_e.label) {
                    case 0:
                        if (this.storage.lists && !force) {
                            return [2 /*return*/, this.storage.lists];
                        }
                        isIe = typeof window !== 'undefined' &&
                            /MSIE|Trident/.test((_b = window.navigator) === null || _b === void 0 ? void 0 : _b.userAgent);
                        bustIeCache = isIe ? ["bustIeCache".concat(Date.now())] : [];
                        request = this.shoppingLists.get({
                            queryArgs: {
                                expand: __spreadArray(__spreadArray([], exports.expand, true), bustIeCache, true),
                                where: ["name(en = \"".concat(exports.listName, "\")")].concat((queryArgs === null || queryArgs === void 0 ? void 0 : queryArgs.where) || []),
                                sort: 'createdAt desc',
                            },
                        });
                        return [4 /*yield*/, this.execute(request)];
                    case 1:
                        body = _e.sent();
                        return [2 /*return*/, this.setLists(body.count ? body.results : undefined)];
                }
            });
        });
    };
    Client.prototype.createList = function (body) {
        return this.execute(this.shoppingLists.post({
            body: __assign({ name: { en: exports.listName } }, body),
            queryArgs: { expand: exports.expand },
        }));
    };
    Client.prototype.execute = function (request) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, (0, _1.retry)(function () { return request.execute(); }, {
                            onError: function (error) {
                                return error.message === 'External OAuth did not respond in time.';
                            },
                            retries: 1,
                        })];
                    case 1: return [2 /*return*/, (_a.sent()).body];
                }
            });
        });
    };
    Client.prototype.prefixError = function (error, prefix) {
        if (!(error instanceof Error)) {
            return new Error(prefix + error);
        }
        // don't prepend if it looks like we already did
        // TODO: instead, do this with different Error subclasses or something
        if (!error.message.startsWith('while ')) {
            error.message = prefix + error.message;
        }
        return error;
    };
    return Client;
}());
exports.Client = Client;
//# sourceMappingURL=Client.js.map